import AgentsIcon from "assets/admin/agents.svg";
import DashboardIcon from "assets/admin/dashboard.svg";
import EducationIcon from "assets/admin/education.svg";
import FacultyIcon from "assets/admin/faculty.svg";
import FacultyGroupsIcon from "assets/admin/facultyGroups.svg";
import FilesIcon from "assets/admin/files.svg";
import ReportsIcon from "assets/admin/reports.svg";
import SettingsIcon from "assets/admin/setting.svg";
import StaffsIcon from "assets/admin/staffs.svg";
import TicketsIcon from "assets/admin/tickets.svg";
import UsersIcon from "assets/admin/users.svg";
import Agents from "pages/agents";
import ApplicationsList from "pages/all_applications";
import ChatTicket from "pages/chat";
import Dashboard from "pages/dashboard";
import ApplicationDetail from "pages/detail_application";
import Faculty from "pages/faculty";
import FacultyGroups from "pages/facultyGroups";
import MyReferralApplications from "pages/my_application";
import Report from "pages/reports";
import Settings from "pages/settings";
import Staffs from "pages/staffs";
import Users from "pages/users";

export const DashboardRoutes = [
  {
    path: "",
    title: "داشبورد",
    icon: DashboardIcon,
    element: <Dashboard />,
    in_sidebar: true,
  },
  {
    path: "reports",
    title: "گزارشات",
    icon: ReportsIcon,
    element: <Report />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "staffs",
    title: "مدیریت کارمندان",
    icon: StaffsIcon,
    element: <Staffs />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "users",
    title: "مدیریت کاربران",
    icon: UsersIcon,
    element: <Users />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "faculty",
    title: "مدیریت دانشکده ها",
    icon: FacultyIcon,
    element: <Faculty />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "facultyGroups",
    title: "مدیریت گروه ها",
    icon: FacultyGroupsIcon,
    element: <FacultyGroups />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "agents",
    title: "مدیریت ایجنت ها",
    icon: AgentsIcon,
    element: <Agents />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "settings",
    title: "تنظیمات",
    icon: SettingsIcon,
    element: <Settings />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "tickets",
    title: "تیکت ها",
    icon: TicketsIcon,
    element: <ChatTicket />,
    in_sidebar: true,
    superuser: true,
  },
  {
    path: "my-referral-applications",
    title: "پرونده های من",
    icon: EducationIcon,
    element: <MyReferralApplications />,
    in_sidebar: true,
  },
  {
    path: "all-files",
    title: "همه پرونده ها",
    icon: FilesIcon,
    element: <ApplicationsList />,
    in_sidebar: true,
  },
  {
    path: "all-files/detail/:id",
    title: "جزئیات پرونده",
    icon: FilesIcon,
    element: <ApplicationDetail />,
    in_sidebar: false,
  },
];
